/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".row[_ngcontent-%COMP%]{margin-left:0!important;margin-right:0!important}.cotenedor-datos[_ngcontent-%COMP%]{height:340px}"];
export { styles as styles };
